// Notification feature constants — kept isolated so both the provider and
// its tests reference a single source of truth.

export const POLL_INTERVAL_MS = 30000;
export const HISTORY_LIMIT = 50;
export const TOAST_MAX_VISIBLE = 3;
export const TOAST_AUTO_DISMISS_MS = 6000;
export const HIDDEN_RESYNC_THRESHOLD_MS = 60000;
// A single poll pass (periodic tick or post-resync catch-up) that surfaces
// more than this many previously-unseen tickets collapses into one
// aggregated toast instead of one toast per ticket. The spec calls this out
// explicitly for the post-resync catch-up; this implementation applies the
// same rule to every poll pass for consistent, simpler behavior.
export const TOAST_AGGREGATE_THRESHOLD = 3;
